import React from "react";
import { MenuItem, Select, Skeleton, Stack, Typography, selectClasses } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ChevronDown from "src/icons/ChevronDown";
import Chip from "@hyro-components/Chip";
import palette from "src/theme/palette";

const SetupSelect = ({ setups, selectedSetup, hasOverrides, onChange, loading }) => {
  const selectedOption = setups?.find((s) => s.id === selectedSetup);

  return (
    <Select
      value={selectedSetup || ""}
      onChange={(e) => onChange(e.target.value)}
      displayEmpty
      IconComponent={(props) => (
        <ChevronDown {...props} style={{ top: "unset", right: 12 }} />
      )}
      renderValue={() => (
        <Stack direction="row" alignItems="center" gap={1} sx={{ flex: 1 }}>
          <Stack direction="column" gap="2px" justifyContent="center" sx={{ flex: 1, minWidth: 0 }}>
            {loading ? (
              <>
                <Skeleton variant="text" width={80} sx={{ fontSize: "16px" }} />
                <Skeleton variant="text" width={280} sx={{ fontSize: "14px" }} />
              </>
            ) : (
              <>
                <Typography variant="body1">{selectedOption?.name || ""}</Typography>
                <Typography variant="body2" color="text.700">
                  {selectedOption?.description || ""}
                </Typography>
              </>
            )}
          </Stack>
          {!loading && hasOverrides && (
            <Chip
              label="Custom"
              size="small"
              backgroundColorPath={["tertiary", "300"]}
              textColorPath={["primary", "main"]}
              sx={{ mr: "8px" }}
            />
          )}
        </Stack>
      )}
      sx={{
        bgcolor: palette.system[0],
        border: 1,
        lineHeight: "20px",
        borderColor: palette.grey[300],
        borderRadius: 1,
        maxWidth: 600,
        [`& .${selectClasses.select}`]: {
          px: "18px",
          py: "16px"
        },
        "& fieldset": { border: "none" }
      }}
      MenuProps={{
        sx: { "& .MuiList-root": { display: "flex", flexDirection: "column", gap: "4px" }, mt: "4px" }
      }}
    >
      {setups?.map((setup) => {
        const isSelected = setup.id === selectedSetup;

        return (
          <MenuItem key={setup.id} value={setup.id} sx={{ borderRadius: "8px" }}>
            <Stack direction="row" alignItems="center" gap={1} sx={{ flex: 1 }}>
              <Stack direction="column" gap="4px" sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body1">{setup.name}</Typography>
                <Typography variant="body2" color="text.700">
                  {setup.description}
                </Typography>
              </Stack>
              {isSelected && <CheckIcon sx={{ color: palette.primary[500] }} />}
            </Stack>
          </MenuItem>
        );
      })}
    </Select>
  );
};

export default SetupSelect;
